'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedState = void 0;
var constants_1 = require("./constants");
var EmbedState;
(function (EmbedState) {
    /**
   * UserInterface State Object
   */
    var EmbedUserInterfaceState = /** @class */ (function () {
        function EmbedUserInterfaceState() {
            this.hidden = []; //default
            this.isFullscreen = false; //default
            this.isSoftKeyboardVisible = false; //default
            this.isCopyAllowed = true;
            this.isPasteAllowed = true;
            this.isFileUploadAllowed = true;
            this.isFileDownloadAllowed = true;
        }
        EmbedUserInterfaceState.prototype.updateState = function (newState) {
            var stateDiff = {};
            if (newState) {
                if (newState.hidden !== undefined && (newState.hidden instanceof Array)) {
                    this.hidden = newState.hidden;
                    stateDiff[EmbedUserInterfaceState.HIDDEN_KEY] = this.hidden;
                }
                if (newState.isFullscreen !== undefined) {
                    this.isFullscreen = newState.isFullscreen;
                    stateDiff[EmbedUserInterfaceState.IS_FULLSCREEN_KEY] = this.isFullscreen;
                }
                if (newState.isSoftKeyboardVisible !== undefined) {
                    this.isSoftKeyboardVisible = newState.isSoftKeyboardVisible;
                    stateDiff[EmbedUserInterfaceState.IS_SOFT_KEYBOARD_VISIBLE_KEY] = this.isSoftKeyboardVisible;
                }
                if (newState.isCopyAllowed !== undefined) {
                    this.isCopyAllowed = newState.isCopyAllowed;
                    stateDiff[EmbedUserInterfaceState.IS_COPY_ALLOWED_KEY] = this.isCopyAllowed;
                }
                if (newState.isPasteAllowed !== undefined) {
                    this.isPasteAllowed = newState.isPasteAllowed;
                    stateDiff[EmbedUserInterfaceState.IS_PASTE_ALLOWED_KEY] = this.isPasteAllowed;
                }
                if (newState.isFileUploadAllowed !== undefined) {
                    this.isFileUploadAllowed = newState.isFileUploadAllowed;
                    stateDiff[EmbedUserInterfaceState.IS_FILE_UPLOAD_ALLOWED_KEY] = this.isFileUploadAllowed;
                }
                if (newState.isFileDownloadAllowed !== undefined) {
                    this.isFileDownloadAllowed = newState.isFileDownloadAllowed;
                    stateDiff[EmbedUserInterfaceState.IS_FILE_DOWNLOAD_ALLOWED_KEY] = this.isFileDownloadAllowed;
                }
            }
            return stateDiff;
        };
        EmbedUserInterfaceState.HIDDEN_KEY = "hidden";
        EmbedUserInterfaceState.IS_FULLSCREEN_KEY = 'isFullscreen';
        EmbedUserInterfaceState.IS_SOFT_KEYBOARD_VISIBLE_KEY = 'isSoftKeyboardVisible';
        EmbedUserInterfaceState.IS_COPY_ALLOWED_KEY = 'isCopyAllowed';
        EmbedUserInterfaceState.IS_PASTE_ALLOWED_KEY = 'isPasteAllowed';
        EmbedUserInterfaceState.IS_FILE_UPLOAD_ALLOWED_KEY = 'isFileUploadAllowed';
        EmbedUserInterfaceState.IS_FILE_DOWNLOAD_ALLOWED_KEY = 'isFileDownloadAllowed';
        return EmbedUserInterfaceState;
    }());
    EmbedState.EmbedUserInterfaceState = EmbedUserInterfaceState;
    /**
    * Session State Object
    */
    var EmbedSessionState = /** @class */ (function () {
        function EmbedSessionState() {
            this.sessionStatus = constants_1.EmbedConstants.SessionStatus.Unknown;
        }
        /**
         * Flow: embed-service.ts (sendSessionStateUpdate) --> embed-helper.ts (handleEvent) --> embed-helper.ts (_handleEventV1)
         * --> embed-helper.ts (updateSessionState)
         *
         * EmbedSessionState.updateState is called by specifying an object KEY and VALUE. So, as long as
         * the parameter -- newState -- contains the KEY, we will look for that KEY, establishing mapping from newState.
         */
        EmbedSessionState.prototype.updateState = function (newState) {
            var stateDiff = {};
            if (newState && newState.sessionStatus !== undefined && this.sessionStatus !== constants_1.EmbedConstants.SessionStatus.Ended) {
                this.sessionStatus = newState.sessionStatus;
                stateDiff[EmbedSessionState.SESSION_STATUS_KEY] = constants_1.EmbedConstants.SessionStatus[this.sessionStatus];
                if (newState.sessionTerminationReason) {
                    this.sessionTerminationReason = newState.sessionTerminationReason;
                    stateDiff[EmbedSessionState.SESSION_TERMINATION_REASON_KEY] = this.sessionTerminationReason;
                }
                if (newState.sessionDisconnectionReason) {
                    this.sessionDisconnectionReason = newState.sessionDisconnectionReason;
                    stateDiff[EmbedSessionState.SESSION_DISCONNECTION_REASON_KEY] = this.sessionDisconnectionReason;
                }
                if (newState.redirectURL) {
                    this.redirectURL = newState.redirectURL;
                    stateDiff[EmbedSessionState.REDIRECT_URL_KEY] = this.redirectURL;
                }
                if (newState.sessionId) {
                    this.sessionId = newState.sessionId;
                    stateDiff[EmbedSessionState.SESSION_ID] = this.sessionId;
                }
            }
            return stateDiff;
        };
        EmbedSessionState.SESSION_STATUS_KEY = "sessionStatus";
        EmbedSessionState.SESSION_TERMINATION_REASON_KEY = "sessionTerminationReason";
        EmbedSessionState.SESSION_DISCONNECTION_REASON_KEY = "sessionDisconnectionReason";
        EmbedSessionState.REDIRECT_URL_KEY = "redirectURL";
        EmbedSessionState.SESSION_ID = "sessionId";
        return EmbedSessionState;
    }());
    EmbedState.EmbedSessionState = EmbedSessionState;
})(EmbedState = exports.EmbedState || (exports.EmbedState = {}));
